import { useEffect, useState } from "react";
import { formatPageDateTime } from "../utils/dateTime";

const CLOCK_UPDATE_INTERVAL_MS = 1000;

export function usePageDateTime() {
  const [dateTime, setDateTime] = useState(() =>
    formatPageDateTime(new Date()),
  );

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setDateTime(formatPageDateTime(new Date()));
    }, CLOCK_UPDATE_INTERVAL_MS);

    return () => window.clearInterval(intervalId);
  }, []);

  return dateTime;
}
